"use client"

import Image from "next/image"
import { useState } from "react"
import { clientLogos } from "@/features/home/data"

function ClientLogoItem({ logo }: { logo: typeof clientLogos[0] }) {
  const [hasImage, setHasImage] = useState(Boolean(logo.logo))

  return (
    <div className="group flex h-20 min-w-64 shrink-0 items-center justify-center rounded-2xl border border-border/70 bg-background/70 px-6 transition-[border-color,background-color] duration-300 hover:border-primary/35 hover:bg-background">
      {hasImage && logo.logo ? (
        <div className="flex items-center gap-3">
          <Image
            src={logo.logo}
            alt={`${logo.name} logo`}
            width={96}
            height={48}
            className="max-h-11 w-auto max-w-24 object-contain opacity-55 grayscale transition-[opacity,filter] duration-300 group-hover:opacity-100 group-hover:grayscale-0"
            onError={() => setHasImage(false)}
          />
          <span className="font-[family-name:var(--font-heading)] text-sm font-semibold text-foreground whitespace-nowrap">
            {logo.name}
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-3 opacity-60 transition-opacity duration-300 group-hover:opacity-100">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <span className="font-[family-name:var(--font-heading)] text-sm font-bold">
              {logo.initials}
            </span>
          </div>
          <span className="font-[family-name:var(--font-heading)] text-sm font-semibold text-foreground whitespace-nowrap">
            {logo.name}
          </span>
        </div>
      )}
    </div>
  )
}

export function LogosStrip() {
  return (
    <section className="relative py-8 sm:py-12 border-y border-border/40 overflow-hidden" aria-label="Referans müşterilerimiz">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl mb-5 sm:mb-6">
        <p className="text-center text-xs sm:text-sm text-muted-foreground uppercase tracking-widest font-medium">
          Bizi Tercih Eden Müşterilerimiz
        </p>
      </div>

      <div className="relative logo-marquee">
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

        <div className="flex w-max animate-logo-marquee">
          {[0, 1].map((setIndex) => (
            <div
              key={setIndex}
              className="flex shrink-0 gap-5 pr-5 sm:gap-6 sm:pr-6"
              aria-hidden={setIndex === 1}
            >
              {clientLogos.map((logo) => (
                <ClientLogoItem key={`${setIndex}-${logo.name}`} logo={logo} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
